import { RequestApi } from "@omnijus/common";
import { CLIENT_ID } from "../../services/client-id";
import { FiltroCliente } from "./models/filtro-cliente";
import { FiltroContrato } from "./models/filtro-contrato";
import { FiltroEmpresa } from "./models/filtro-empresa";

const filtrosClienteUrl = process.env.REACT_APP_BFF_OPERACIONAL_API_URL + "/api/Cliente/v1";

const requestApi = new RequestApi(CLIENT_ID);

export const FiltrosClienteService = {
    listarClientes: () => {
        const url = `${filtrosClienteUrl}/Cliente/ListarClienteParaAgenteOperacional`;
        return requestApi.get<FiltroCliente[]>(url);
    },
    listarContratos: (idCliente?: string) => {
        const url = new URL(`${filtrosClienteUrl}/Contrato/ObterContratoPorCliente`);
        idCliente && url.searchParams.set("idCliente", idCliente);
        return requestApi.get<FiltroContrato[]>(url.toString());
    },
    listarEmpresas: (idContrato?: string) => {
        const url = new URL(`${filtrosClienteUrl}/EmpresaCliente/ListarEmpresasContrato`);
        idContrato && url.searchParams.set("idContrato", idContrato);
        return requestApi.get<FiltroEmpresa[]>(url.toString());
    },
};
